import { ProjectCategory } from '../types';

/**
 * Format date string to localized format
 * @param dateString - ISO date string
 * @returns Formatted date string (e.g., "Jan 15, 2025")
 */
export const formatDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};

/**
 * Get Tailwind color classes for project category badge
 * @param category - Project category
 * @returns Tailwind CSS classes for background and text color
 */
export const getCategoryColor = (category: ProjectCategory): string => {
    const colors: Record<ProjectCategory, string> = {
        tool: 'bg-blue-100 text-blue-700',
        template: 'bg-purple-100 text-purple-700',
        widget: 'bg-green-100 text-green-700',
        automation: 'bg-orange-100 text-orange-700',
        app: 'bg-emerald-100 text-emerald-700',
    };
    return colors[category];
};
